
import { Step } from "@/lib/types";

export const reposterDashboardStep: Step = {
  id: "reposter-dashboard",
  type: "step",
  title: "Onboard to your reposter dashboard",
  description: `
  We created an internal tool to handle all our content management.

  We call it the Reposter Dashboard.

  This is where you'll log-in to see the content you'll have to repost. This is also where you'll mark posts as posted so we can track your work.
  `,
  todos: [
    {
      id: "ask-signup-link",
      text: "Ask for your personalized sign-up link on Upwork",
      completed: false
    },
    {
      id: "save-signup-link",
      text: "Save your signup link",
      completed: false
    },
    {
      id: "login-dashboard",
      text: "Log-in to the reposter dashboard and confirm everything is working",
      completed: false
    }
  ],
  buttonText: "I asked, continue"
};
